import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerWorkspaceSettingsMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('workspaceSettings', locale)
}
